import { FieldType, ViewModelBase } from "@shoothill/core";
import { Amendment } from "Globals/Models/Amendment";
import { AmendmentModel } from "Globals/Models/Domain/Admin/applicant/AmendmentModel";
import { action, computed } from "mobx";
import { StoresInstance } from "../../Stores";
import { AppUrls } from "AppUrls";
const domainStores = StoresInstance.Domain;

export default class AmendmentViewModel extends ViewModelBase<AmendmentModel> {
    constructor(amendment: AmendmentModel) {
        super(amendment);
    }

    @action
    public save = async (): Promise<void> => {
        try {
            if ((await this.isModelValid()) && this.isModelDirty) {
                this.setIsLoading(true);
                let upsert: Amendment = this.model.toDto();
                const apiResult = await this.Post<Amendment>(AppUrls.Server.Admin.Upsert.Amendment, upsert);
                if (apiResult.wasSuccessful) {
                    this.model.fromDto(apiResult.payload);
                    console.info("Amendment:Upsert-Successful");
                } else {
                    throw new Error(apiResult.errors[0].message);
                }
            }
        } catch (exception) {
            console.error("Amendment:Upsert-Error", exception);
        } finally {
            this.setIsLoading(false);
        }
    };

    @computed
    public get isModelDirty(): boolean {
        let dirty = false;
        Object.keys(this.model).forEach((field) => {
            if (this.model.getDirty(field as keyof FieldType<AmendmentModel>)) {
                dirty = true;
            }
        });
        return dirty;
    }

    public async isFieldValid(fieldName: keyof FieldType<AmendmentModel>, value: any): Promise<boolean> {
        let { isValid, errorMessage } = await this.validateDecorators(fieldName);

        this.setError(fieldName, errorMessage);
        this.setValid(fieldName, isValid);

        return isValid;
    }

    public afterUpdate: undefined;
    public beforeUpdate: undefined;
}
